import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  myWalletVirtualCardDetailRouteProps,
  VirtualCardDetailMatchParams,
  virtualCardDetailRouteProps,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

export const selectVirtualCardIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<VirtualCardDetailMatchParams>(
      backgroundLocation.pathname,
      virtualCardDetailRouteProps,
    ) as match<VirtualCardDetailMatchParams>
    return mtch?.params.id
  },
)

export const selectMyWalletVirtualCardIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<VirtualCardDetailMatchParams>(
      backgroundLocation.pathname,
      myWalletVirtualCardDetailRouteProps,
    ) as match<VirtualCardDetailMatchParams>
    return mtch?.params?.id
  },
)

export const selectGetVirtualCardFailed = (state: RootState): boolean =>
  state.app.virtualCardDetail.getVirtualCardFailed
